<template>
  <div class="container-fluid h-100 pb-3 pt-5">
    <HomePage v-if="$route.name === 'home'" />
    <TPMApp v-else-if="$route.name === 'tpm'" />
    <TPMAdmin v-else-if="$route.name === 'tpmadmin'" />
    <UserAccountForm v-else-if="$route.name === 'account'" />
    <OrgAdmin v-else-if="$route.name === 'organization'" />
    <JoinOrgRequestPage v-else-if="$route.name === 'joinOrgRequest'" />
    <ProjChklstApp v-else-if="$route.name === 'projchklst'" />
    <FilesApp v-else-if="$route.name === 'files'" />
    <MonitorApp v-else-if="$route.name === 'monitor'" />
    <CRMApp v-else-if="$route.name === 'crm'" />

    <Footer />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Footer from '@/components/Footer.vue'
import HomePage from '@/pages/HomePage.vue'
import UserAccountForm from '@/components/UserAccountForm.vue'
import OrgAdmin from '@/components/OrgAdmin.vue'
import TPMApp from '@/components/apps/TPM/App.vue'
import TPMAdmin from '@/components/apps/TPM/Admin.vue'
import JoinOrgRequestPage from '@/pages/JoinOrgRequestPage.vue'
import ProjChklstApp from '@/components/apps/PROJCHKLST/App.vue'
import FilesApp from '@/components/apps/FILES/App.vue'
import MonitorApp from '@/components/apps/MONITOR/App.vue'
import CRMApp from '@/components/apps/CRM/App.vue'

export default {
  name: 'LoggedInContent',
  components: {
    Footer,
    HomePage,
    UserAccountForm,
    OrgAdmin,
    TPMApp,
    TPMAdmin,
    JoinOrgRequestPage,
    ProjChklstApp,
    FilesApp,
    MonitorApp,
    CRMApp
  },
  computed: mapGetters('auth', ['isloggedin'])
}

</script>
